/**
 * @enum {number}
 */
const EBoardCardType = {
    CANDIDACY: 1,
    HUNT: 2,
}

export default EBoardCardType
